// @flow
import React from 'react'
import { StyledA, SecondInfoRibbon } from '../StyledElements'
import styled from 'styled-components'
import Tooltip from 'src/components/Tooltip'
import { TOOLTIP_TYPES } from 'src/ducks/Tooltips/TooltipData'

type TandCRibbonProps = {
  toggleTerms: any
}

const StyledSpan = styled.span`
  font-family: 'RelativeBook';
  font-size: 16px;
  padding-bottom: 10px;
  line-height: 1.5;
  margin-top: 10px;
  display: block;
`

export function TandCRibbon(props: TandCRibbonProps) {
  const { toggleTerms } = props

  return (
    <SecondInfoRibbon>
      <b>Please Note</b>
      <StyledSpan>
        {`To apply for this room at this stage, you will be charged a holding deposit, which is equivalent to one week's license fee (the "Holding Deposit") and a Membership Joining Fee.`}
        <br />
        <br />
        If the booking is successful, you will enter into a licence agreement with us, where you
        will be required to pay your remaining deposit (security bond) before you move in. Your
        holding deposit will become part of your security bond which will be held on trust for the
        Member by The Collective until the end of the Membership Period.
        <br />
        <br />
        The Holding Deposit is non-refundable should you decide to cancel your application before
        entering into a Membership Agreement with us. Please see
        <StyledA onClick={evt => toggleTerms(evt, true)}>terms & conditions</StyledA> for further
        details.
        <br />
        <br />
        *Security Bond
        <Tooltip variation="black" type={TOOLTIP_TYPES.SECURITY_BOND} />
      </StyledSpan>
    </SecondInfoRibbon>
  )
}



// WEBPACK FOOTER //
// ./src/containers/SecureRoom/components/index.js